import axios, { type InternalAxiosRequestConfig } from "axios";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach fallback token from localStorage if present (cookie-first)
api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const fallback = localStorage.getItem("fallbackToken");
  // console.log("Fallback token: ", fallback);
  if (fallback && config && !config.headers?.Authorization) {
    config.headers.Authorization = `Bearer ${fallback}`;
  }
  return config;
});

// On 401: try refresh once, then retry original request
// let isRefreshing = false;
// let refreshPromise: Promise<any> | null = null;

// api.interceptors.response.use(
//   (res) => res,
//   async (error: AxiosError) => {
//     const original = error.config as AxiosRequestConfig & { _retry?: boolean };

//     if (error.response?.status === 401 && !original._retry) {
//       // try refresh
//       original._retry = true;
//       if (!isRefreshing) {
//         isRefreshing = true;
//         refreshPromise = api.post("/auth/refresh")
//           .then((r) => {
//             // If server returned accessToken, update fallbackToken only if cookies aren't working
//             const access = r.data?.accessToken;
//             // If cookies are working, server will have set new cookie; fallback token not strictly needed.
//             // But we can update fallbackToken for clients that rely on it.
//             if (access) localStorage.setItem("fallbackToken", access);
//             return access;
//           })
//           .finally(() => {
//             isRefreshing = false;
//             refreshPromise = null;
//           });
//       }

//       try {
//         await refreshPromise;
//         // retry original request
//         return api(original);
//       } catch (err) {
//         // refresh failed — clear fallback token and propagate
//         localStorage.removeItem("fallbackToken");
//         return Promise.reject(error);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

export default api;
